import * as actionTypes from '@store/actions/actionTypes';

const initialState = {
  loading: false,
  loaded: false,
  list: [],
  limit: 10,
  page: 1,
  total: 0,
  start: 0,
  end: 0,
  viewItem: {},
  sort: 'name',
  direction: 'ASC'
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.POLICY_CARRIERS_START:
      return {
        ...state,
        loading: true
      };
    case actionTypes.POLICY_CARRIERS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    default:
      return state;
  }
};

export default reducer;
